const firebaseConfig = {
  apiKey: "AIzaSyDNFz9L1R9vjlfEwyHLbqku9hmPuW35GbA",
  authDomain: "divezone-dev.firebaseapp.com",
  databaseURL: "https://divezone-dev-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "divezone-dev",
  storageBucket: "divezone-dev.firebasestorage.app",
  messagingSenderId: "707731170413",
  appId: "1:707731170413:web:4ec9171ab95e954bd3cb64",
  measurementId: "G-7LQ837D79C"
};

export const environment = {
  production: false,
  useEmulators: false,
  firebase: firebaseConfig
}
